import { createSlice } from '@reduxjs/toolkit';

export const getStorageState = () => {
    const check = JSON.parse(localStorage.getItem('asia_open_state'))
    if (!check) localStorage.setItem('asia_open_state', JSON.stringify([]));
    return JSON.parse(localStorage.getItem('asia_open_state'));
}

const initialState = {
    openLocalStorage: getStorageState()
};

const projectsSlice = createSlice({
    name: 'projects',
    initialState,
    reducers: {
        toggleProjectOpen(state, action) {
            const project = action.payload;
            const newProjects = [...state.openLocalStorage];
            const foundProjectIndex = newProjects.findIndex((p) => p.id === project.id);
            if (foundProjectIndex >= 0) {
                const newState = !(newProjects[foundProjectIndex].isOpen);
                newProjects[foundProjectIndex].isOpen = newState;
                const vv = (newProjects[foundProjectIndex].video ?? [])
                const videos = (newProjects[foundProjectIndex].video ?? []).map((video, i) => {
                    const foundVideo = vv.find(v => v.id === video.id)
                    const newVideoOpenState = newState ? foundVideo ? foundVideo.isOpen : false : false;
                    return {...video, isOpen: newVideoOpenState};
                });
                newProjects[foundProjectIndex].video = [...videos];
            }
            else {
                const newProject = {
                    id: project.id,
                    isOpen: false,
                    video: [],
                };
                newProjects.push(newProject);
            }
            state.openLocalStorage = newProjects;
            localStorage.setItem('asia_open_state', JSON.stringify(newProjects));
        },
        toggleVideoOpen(state, action) {
            console.log('state ',state)
            console.log('action ',action)
            const project = action.payload.project;
            const video = action.payload.video;
            console.log('toggleVideoOpen project ',project)
            console.log('toggleVideoOpen video ',video)
            const newProjects = [...state.openLocalStorage];
            const foundProjectIndex = newProjects.findIndex((p) => p.id === project.id);
            if (foundProjectIndex >= 0) {
                const videos = newProjects[foundProjectIndex].video ?? [];
                const foundVideoIndex = videos.findIndex((v) => v.id === video.id);
                if (foundVideoIndex >= 0) {
                    videos[foundVideoIndex].isOpen = !videos[foundVideoIndex].isOpen
                }
                else {
                    videos.push({
                        id: video.id,
                        isOpen: video.isOpen
                    });
                }
                newProjects[foundProjectIndex].video = [...videos];
            }
            else {
                const newProject = {
                    id: project.id,
                    isOpen: project.isOpen,
                    video: [{id: video.id, isOpen: false}],
                };
                newProjects.push(newProject);
            }
            state.openLocalStorage = newProjects;
            localStorage.setItem('asia_open_state',JSON.stringify(newProjects));
        }
    },
});

export const { toggleProjectOpen, toggleVideoOpen } = projectsSlice.actions;
export default projectsSlice.reducer;
